import { useTranslation } from "react-i18next";
import img from "../../assets/img/illu/environnement.webp";

export default function Place() {
  const { t } = useTranslation();

  return (
    <section className="Place fade">
      <h2>{t("place.title")}</h2>
      <article className="place-img">
        <div className="place-img">
          <img src={img} alt="Vue nature" />
        </div>
        <article className="place-text">
          <p>{t("place.p1")}</p>
          <p>{t("place.p2")}</p>
          <p>{t("place.p3")}</p>
        </article>
        <img src={img} alt="Vue nature" className="place-img-mobile" />
      </article>
      <p className="place-address">{t("place.address")}</p>
    </section>
  );
}
